import { Navigate, Outlet } from 'react-router-dom'
import useAuthStore from '@/stores/useAuthStore'
import Layout from './Layout'

export const ProtectedRoute = () => {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
